export enum BuyerType {
    Individual,
    Business,
    NotAvailable,
}